import { createAsyncThunk } from "@reduxjs/toolkit";
import { additionalKycDataApi, getUserWalletBalanceApi } from "../../utils/api";

export const actionFecthWalletBalance = createAsyncThunk(
  "otc/actionFecthWalletBalance",
  async (email) => {
    const response = await getUserWalletBalanceApi(email);
    return response;
  }
);